const styles = theme => ({
  container: {
    padding: '24px',
  },
  borderBottom: {
    borderBottom: '6px solid #EBEEF3',
    marginBottom: '20px',
    paddingBottom: '10px',
  },
  textBold: {
    fontWeight: 'bold',
    fontSize: '18px',
  },
  textLight: {
    color: '#8C9099',
  },
  totalContainer: {
    color: theme.palette.primary.main,
    fontWeight: '600',
    lineHeight: '24px',
    borderTop: '1px solid #EBEEF3',
    padding: '1.5rem',
  },
  textEnd: {
    textAlign: 'end',
  },
});
export default styles;
